import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface FooterItemProps {
  label: string;
  icon: IconProp;
  onClick?: () => void;
  isActive: boolean;
}

const FooterItem: FC<FooterItemProps> = ({
  label,
  icon,
  onClick,
  isActive,
}) => {
  return (
    <button
      onClick={onClick}
      className={`footer-button ${isActive ? 'active' : ''}`}
      type="button"
      aria-pressed={isActive}
    >
      <div className="footer-button-content">
        <div className="footer-button-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="footer-button-label">{label}</span>
      </div>
    </button>
  );
};

export default FooterItem;
